<template>
	<div>
        <b-row>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('name')">
                    <div class="label-as-input">{{ isNotNullValue(formData.name) }}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('surname')">
                    <div class="label-as-input">{{ isNotNullValue(formData.surname) }}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('academic_year')">
                    <div class="label-as-input">{{ isNotNullValue(formData.academic_year)}}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('amount')">
                    <div class="label-as-input">{{ isNotNullValue(formData.amount)}}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('currency')">
                    <div class="label-as-input">{{ isNotNullValue(formData.currency)}}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('issue_date')">
                    <div class="label-as-input">{{ isNotNullValue(formData.issue_date)}}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('subject')">
                    <div class="label-as-input">{{ isNotNullValue(formData.subject)}}</div>
                </b-form-group>
            </b-col>
        </b-row>
	</div>
</template>

<script>
// Components

// Services
import CustomerBudgetService from "@/services/CustomerBudgetService";

export default {
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            formData: {},
            formLoading: false,
        }
    },
    async created() {
        await this.get(this.formId)
    },
    methods: {
        get(id) {
            CustomerBudgetService.get(id)
                          .then(response => {
                              this.formData = response.data.data;
                          })
                          .catch(e => {
                              this.showErrors(e)
                          })
        },
    }
}
</script>
